import { __rest } from "tslib";
import * as React from 'react';
import { Button } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
export var ModalBoxCloseButton = function ModalBoxCloseButton(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      props = __rest(_a, ["className", "onClose"]);

  return React.createElement(Button, Object.assign({
    className: className,
    variant: "plain",
    onClick: onClose,
    "aria-label": "Close"
  }, props), React.createElement(TimesIcon, null));
};